var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.306 15.11a6.456 6.456 0 0 1 3.075-5.418 6.61 6.61 0 0 0-5.207-2.815c-2.191-.23-4.315 1.31-5.432 1.31-1.138 0-2.857-1.287-4.708-1.25a6.935 6.935 0 0 0-5.836 3.56c-2.523 4.369-.64 10.79 1.776 14.32 1.21 1.73 2.623 3.661 4.472 3.593 1.81-.075 2.486-1.154 4.67-1.154 2.165 0 2.799 1.154 4.686 1.11 1.942-.031 3.165-1.736 4.332-3.482a14.304 14.304 0 0 0 1.981-4.035 6.24 6.24 0 0 1-3.809-5.74ZM15.742 4.554A6.357 6.357 0 0 0 17.196 0a6.468 6.468 0 0 0-4.185 2.165 6.048 6.048 0 0 0-1.492 4.386 5.348 5.348 0 0 0 4.223-1.997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.af5af991e1e54eede01db4c43b9c6831.svg";
export { ForwardRef as ReactComponent };